import FunctionIndex from '@/pages/functions/Index'
import FunctionForm from '@/pages/functions/Form'

const FunctionsRoutes = [
    {path: '/function', name: 'functions', component: FunctionIndex, meta: {perfil: 'root'}},
    {path: '/function/create', name: 'functions.create', component: FunctionForm, meta: {perfil: 'root'}},
    {path: '/function/edit/:id', name: 'functions.edit', component: FunctionForm, meta: {perfil: 'root'}},
];

export default FunctionsRoutes;
